import { Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Field, FieldProps, useFormikContext } from 'formik';
import { GradeLevel } from 'models';
import React from 'react';
import { LessonForm } from '../types';
import StepContainer from './StepContainer';

const BasicInfoForm: React.FC = () => {
  const { setFieldValue } = useFormikContext();

  const handleGradeLevelChange = (
    _: React.ChangeEvent<{}>,
    value: GradeLevel | GradeLevel[] | null,
  ) => {
    setFieldValue('basicInfo.gradeLevels', value);
  };

  return (
    <StepContainer>
      <Grid item>
        <Typography gutterBottom>Tell us about the lesson you’re submitting:</Typography>
      </Grid>
      <Grid item>
        <Field name="basicInfo.lesson.title">
          {({ field, meta }: FieldProps<LessonForm['basicInfo']['lesson']['title']>) => (
            <TextField
              id="lesson-title"
              label="Lesson Title"
              required
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              error={meta.touched && Boolean(meta.error)}
              helperText={meta.touched && meta.error}
              {...field}
            />
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="basicInfo.lesson.description">
          {({ field, meta }: FieldProps<LessonForm['basicInfo']['lesson']['description']>) => (
            <TextField
              id="lesson-description"
              label="Lesson Description"
              multiline
              rows="4"
              required
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              error={meta.touched && Boolean(meta.error)}
              helperText={meta.touched && meta.error}
              {...field}
            />
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="basicInfo.gradeLevels">
          {({ field, meta, form }: FieldProps<LessonForm['basicInfo']['gradeLevels']>) => (
            <Autocomplete<GradeLevel, boolean>
              {...field}
              multiple
              id="grade-levels"
              options={Object.values(GradeLevel)}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grade Levels"
                  helperText={
                    meta.touched && Boolean(meta.error) ? meta.error : 'Select all that apply.'
                  }
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={meta.touched && Boolean(meta.error)}
                />
              )}
              onChange={handleGradeLevelChange}
              onBlur={(e) => {
                form.setFieldTouched('basicInfo.gradeLevels', true);
                field.onBlur(e);
              }}
            />
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="basicInfo.cstaStandards">
          {({ field, meta }: FieldProps<LessonForm['basicInfo']['cstaStandards']>) => (
                <TextField
                id='csta-standards'
                  label="CSTA Standards"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  helperText={
                    meta.touched && Boolean(meta.error) ? meta.error : 'Please add the code for each relevant standard below, using the format XX-XX-XX. Separate standards using a comma. (e.g. - 1A-AP-12, 1B-IC-20, 2K-NI-06). For more information about the standards, see: https://www.csteachers.org/page/about-csta-s-k-12-nbsp-standards'
                  }
                  error={meta.touched && Boolean(meta.error)}
                  {...field}
                />

          )}
        </Field>
      </Grid>
    </StepContainer>
  );
};

export default BasicInfoForm;
